import { e_switchListsbBy, I_RootState } from './interfaces';
import * as actionTypes from './actionTypes';

const TravelPavilionGroupID = new URLSearchParams(window.location.search).get(
    'TravelPavilionGroupID'
);
const Keywords = new URLSearchParams(window.location.search).get('Keywords');

const initialState: I_RootState = {
    FilterItems: [],
    TempFilterItems: [],
    SortType: TravelPavilionGroupID ? undefined : Keywords ? -1 : 3, // 關鍵字搜尋預設依關聯度:目的地搜尋預設為依出發日
    SwitchListBy: e_switchListsbBy.List, // 初始設為依行程列表 List
    TagFiltersShow: [], // 特色標籤展開項目，預設都不展開
    TempTagFiltersShow: [], // 特色標籤展開項目，預設都不展開
    PackageInfo: [],
    GroupListInfo: {
        data: undefined,
        isLoading: true,
    },
    GroupListInfoM: {
        data: undefined,
        isLoading: true,
        PageSize: 10,
    },
    SingleGroupListInfo: {
        data: undefined,
        isLoading: true,
    },
    SingleGroupListInfoM: {
        data: undefined,
        isLoading: true,
        PageSize: 10,
    },
    DepthInfoIsLoading: true,
    ChangeItem: false,
    Tags: '',
    Trigger: '',
    callJson: {
        Data: [],
        Token: '',
        TokenExpires: '',
        TraceId: '',
        rCode: '',
        rDesc: '',
        isCompleted: false,
    },
};

const reducer = (state: I_RootState = initialState, action: any) => {
    switch (action.type) {
        case actionTypes.SET_GROUPLISTINFO:
            return { ...state, GroupListInfo: { ...state.GroupListInfo, isLoading: true } };
        case actionTypes.SET_GROUPLISTINFO_SUCCESS:
            return { ...state, GroupListInfo: { data: action.payload, isLoading: false } };
        case actionTypes.SET_GROUPLISTINFOM:
            return {
                ...state,
                GroupListInfoM: {
                    ...state.GroupListInfoM,
                    PageSize: action.payload.PageSize,
                    isLoading: true,
                },
            };
        case actionTypes.SET_GROUPLISTINFOM_SUCCESS:
            return {
                ...state,
                GroupListInfoM: {
                    ...state.GroupListInfoM,
                    data: action.payload,
                    isLoading: false,
                },
            };
        case actionTypes.SET_SINGLEGROUPLISTINFO:
            return {
                ...state,
                SingleGroupListInfo: { ...state.SingleGroupListInfo, isLoading: true },
            };
        case actionTypes.SET_SINGLEGROUPLISTINFO_SUCCESS:
            return { ...state, SingleGroupListInfo: { data: action.payload, isLoading: false } };
        case actionTypes.SET_SINGLEGROUPLISTINFOM:
            return {
                ...state,
                SingleGroupListInfoM: {
                    ...state.SingleGroupListInfoM,
                    PageSize: action.payload.PageSize,
                    isLoading: true,
                },
            };
        case actionTypes.SET_SINGLEGROUPLISTINFOM_SUCCESS:
            return {
                ...state,
                SingleGroupListInfoM: {
                    ...state.SingleGroupListInfoM,
                    data: action.payload,
                    isLoading: false,
                },
            };
        case actionTypes.SET_DEPTHINFO_SUCCESS:
            return { ...state, DepthInfoIsLoading: false, DepthInfo: action.payload };
        case actionTypes.SET_FILTERITEMS:
            return { ...state, FilterItems: action.payload };
        case actionTypes.SET_TEMPFILTERITEMS:
            return { ...state, TempFilterItems: action.payload };
        case actionTypes.SET_SORTTYPE:
            return { ...state, SortType: action.payload };
        case actionTypes.SET_SWITCHLISTBY:
            return { ...state, SwitchListBy: action.payload };
        case actionTypes.SET_TAGFILTERS_SHOW:
            return { ...state, TagFiltersShow: action.payload };
        case actionTypes.SET_TEMPTAGFILTERS_SHOW:
            return { ...state, TempTagFiltersShow: action.payload };
        case actionTypes.SET_PAGESIZEM:
            return { ...state, PageSizeM: action.payload };
        case actionTypes.SET_CHANGEITEM:
            return { ...state, ChangeItem: action.payload };
        case actionTypes.SET_TAGS:
            return { ...state, Tags: action.payload };
        case actionTypes.SET_TRIGGER:
            return { ...state, Trigger: action.payload };
        case actionTypes.SET_CALLJSON:
            return { ...state, callJson: { isCompleted: false, ...action.payload } };
        case actionTypes.SET_CALLJSON_SUCCESS:
            return { ...state, callJson: { isCompleted: true, ...action.payload } };
        case actionTypes.SET_GROUPLISTINFOM_SUCCESS_ISMORESCHEDULE: {
            const group = [
                ...(state.GroupListInfoM.data?.NormGroupList || []),
                ...action.payload.NormGroupList,
            ];
            const dataGroup = { ...action.payload, NormGroupList: group };
            return {
                ...state,
                GroupListInfoM: { ...state.GroupListInfoM, data: dataGroup, isLoading: false },
            };
        }
        case actionTypes.SET_SINGLEGROUPLISTINFOM_SUCCESS_ISMORESCHEDULE: {
            const list = [
                ...(state.SingleGroupListInfoM.data?.SingleGroupList || []),
                ...action.payload.SingleGroupList,
            ];
            const dataList = { ...action.payload, SingleGroupList: list };
            return {
                ...state,
                SingleGroupListInfoM: {
                    ...state.SingleGroupListInfoM,
                    data: dataList,
                    isLoading: false,
                },
            };
        }
        default:
            return state;
    }
};

export default reducer;
